import { SvgProps } from "@/utils/types";

export const Egg = ({
  primaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="44"
      height="49"
      viewBox="0 0 44 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_586)">
        <path
          d="M36.6604 24.3568C38.8487 32.0829 34.3618 40.1302 26.6261 42.3212C18.8904 44.5121 10.8624 40.0198 8.67138 32.2841C6.48041 24.5484 8.75178 8.67882 16.4779 6.49057C24.204 4.30233 34.4722 16.6307 36.6631 24.3665L36.6604 24.3568Z"
          fill={primaryColor}
        />
        <path
          d="M27.1602 44.207C18.4046 46.6868 9.26541 41.5738 6.78558 32.8182C5.57564 28.5463 5.63815 22.2718 6.95006 16.849C8.57125 10.133 11.768 5.78743 15.9438 4.60474C20.1195 3.42205 25.1203 5.44589 30.0225 10.3143C33.9832 14.2436 37.3267 19.5535 38.5366 23.8254C41.0165 32.581 35.9131 41.7175 27.1575 44.1974L27.1602 44.207ZM17.012 8.37638C10.8831 10.1123 8.47381 24.4307 10.5503 31.7623C12.4415 38.4397 19.4174 42.3362 26.0947 40.445C32.7721 38.5537 36.6686 31.5779 34.7773 24.9006C32.7008 17.5689 23.1409 6.6405 17.012 8.37638Z"
          fill={outlineColor}
        />
        <path
          d="M15.9714 33.8023C16.9917 33.5133 17.5845 32.452 17.2955 31.4317C17.0066 30.4114 15.9452 29.8186 14.925 30.1076C13.9047 30.3965 13.3119 31.4579 13.6009 32.4781C13.8898 33.4984 14.9511 34.0912 15.9714 33.8023Z"
          fill={outlineColor}
        />
        <path
          d="M13.994 28.1782C14.2113 28.0647 14.4698 27.9499 14.7735 27.8847C15.2023 27.7841 15.4629 27.3465 15.3334 26.9258C14.9953 25.8056 14.5361 23.5971 14.721 20.2501C14.7768 19.3093 13.4491 19.0617 13.1736 19.9608C12.93 20.7885 12.7272 21.7606 12.6285 22.8798C12.5031 24.2353 12.5325 25.8068 12.8044 27.611C12.8869 28.1592 13.5003 28.4532 13.9844 28.181L13.994 28.1782Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_586">
          <rect
            width="33"
            height="41.16"
            fill="white"
            transform="translate(0.0682373 9.10114) rotate(-15.8136)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
